import React, { FC } from 'react'
import { useTheme } from '@shared/lib'

const MultitransferIcon: FC = () => {
  const theme = useTheme()

  return (
    <svg width="39" height="12" viewBox="0 0 39 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.9824 0.431824C16.4398 0.115708 17.0664 0.440233 17.0664 0.993347V7.79706C17.0661 8.31108 16.5159 8.64167 16.0566 8.4035L14.9668 7.83807C14.7393 7.72007 14.4638 7.73673 14.2529 7.88202L9.61719 11.0764C9.15966 11.3916 8.5332 11.0665 8.5332 10.5139V5.94257C8.5332 5.71877 8.64407 5.50906 8.8291 5.38104L15.9824 0.431824ZM7.4502 0.12323C7.9077 -0.191583 8.5332 0.13325 8.5332 0.68573V5.258C8.53306 5.48147 8.42296 5.69059 8.23828 5.81854L1.08496 10.7678C0.627548 11.0842 0 10.7595 0 10.2062V3.4035C0 2.88928 0.550394 2.55793 1.00977 2.79608L2.09961 3.36249C2.32715 3.48049 2.60259 3.46286 2.81348 3.31757L7.4502 0.12323ZM25.7207 6.96307L27.8633 0.000183105H30.2637V8.53339H28.6631V1.34784L26.4346 8.53339H24.748L22.5312 1.32343V8.53339H21.0664V0.000183105H23.6152L25.7207 6.96307ZM38.666 1.34784H35.835V8.53339H34.2344V1.34784H31.4141V0.000183105H38.666V1.34784Z"
        fill={theme.colors.icon.secondary}
      />
    </svg>
  )
}

export default MultitransferIcon
